<script lang="ts" setup>
  import type * as CSS from 'csstype'
  import welcomeJson from '@/assets/animations/grilld-welcome.json'

  withDefaults(
    defineProps<{
      backgroundColor?: CSS.Property.BackgroundColor
      color?: CSS.Property.Color
      pauseAnimation?: boolean
    }>(),
    {
      backgroundColor: 'var(--color-base-red)',
      color: 'var(--color-stroke-light)',
      pauseAnimation: false
    }
  )
</script>

<template>
  <client-only>
    <div class="c-page-welcome">
      <Vue3Lottie :animation-data="welcomeJson" :pause-animation="pauseAnimation" class="c-lottie" />
    </div>
  </client-only>
</template>

<style lang="scss" scoped>
  .c-page-welcome {
    flex: 1;

    display: flex;
    justify-content: center;
    align-items: center;

    background-color: v-bind('backgroundColor');

    .c-lottie {
      margin: 32px;
      flex: 1;
      color: v-bind('color');
      fill: v-bind('color');
    }
  }
</style>
